import React, { useState } from 'react';
import coupangLogo from '../../images/info/coupang_logo.png';
import shiptobLogo from '../../images/info/shiptob_logo.png';
import exImg01 from '../../images/info/ex_img_01.png';
import exImg02 from '../../images/info/ex_img_02.png';
import exImg03 from '../../images/info/ex_img_03.png';
import exImg04 from '../../images/info/ex_img_04.png';
import exImg05 from '../../images/info/ex_img_05.png';
import exImg06 from '../../images/info/ex_img_06.png';
import exImg06_1 from '../../images/info/ex_img_06_1.png';
import exImg06_2 from '../../images/info/ex_img_06_2.png';
import exImg06_3 from '../../images/info/ex_img_06_3.png';
import exImg07_1 from '../../images/info/ex_img_07_1.png';
import exImg07_2 from '../../images/info/ex_img_07_2.png';
import arrow from '../../images/info/arrow.png';
import bgEX from '../../images/info/bg_ex.png';
function PlayApiExample() {
    const [coupang, setCoupang] = useState(true);

    //쉽투비일때
    async function onClickShiptob() {
        setCoupang(false);
    }
    //쿠팡일때
    async function onClickCoupang() {
        setCoupang(true);
    }
    return (
        <div id="examplescss">
            <div id="wrap">
                <div id="container" className="exWrap">
                    <div className="contentTitle">
                        <div className="titleText">
                            지금 확인하세요 !
                            <p className="subT">
                                <span className="eng">PLAYAPI</span>를 선택한 서비스
                            </p>
                        </div>
                    </div>
                    <div className="tabArea">
                        <p onClick={onClickCoupang} className={coupang ? 'active' : ''}>
                            쿠팡
                        </p>
                        <p onClick={onClickShiptob} className={coupang ? '' : 'active'}>
                            몰테일쉽투비
                        </p>
                    </div>
                    {!coupang && (
                        <div className="exCon01">
                            <div className="contents ex01">
                                <p className="imgBox">
                                    <img alt="" src={shiptobLogo} />
                                </p>
                                <div className="textBox">
                                    <h3>
                                        <span className="colorPrimary">몰테일쉽투비</span> 서비스란?
                                    </h3>
                                    <p>
                                        쉽투비서비스는 해외 도매사이트에서 경쟁력있는 상품DB를 제공하며, <br />
                                        몰테일을 이용한 물류대행서비스를 제공하고 있습니다. <br />
                                        판매자는 재고 및 배송의 부담없이 쉽고 간편하게 판매할 수 있는 솔루션입니다.
                                    </p>
                                </div>
                            </div>
                            <div className="bg-lightGray">
                                <div className="contents ex02">
                                    <div className="textBox">
                                        <h3>도입한 연동 패키지</h3>
                                        <p>
                                            몰테일쉽투비는 PLAYAPI를 도입해 자사서비스에 주요 판매쇼핑몰과 시스템 연동을
                                            구축하였습니다. <br />
                                            상품관리부터 주문/CS관리까지 지원하는 원스탑 플랫폼을 서비스하고 있습니다.
                                        </p>
                                        <ul>
                                            <li>
                                                <span className="icon icon-ex_icon01"></span>
                                                <b>상품관리</b> : 상품등록 / 상품수정 / 상품품절 / 판매중지
                                            </li>
                                            <li>
                                                <span className="icon icon-ex_icon02"></span>
                                                <b>주문관리</b> : 주문수집 / 배송정보전송 / 취소 / 반품 / 교환
                                            </li>
                                            <li>
                                                <span className="icon icon-ex_icon03"></span>
                                                <b>문의관리</b> : 문의수집 / 답변전송
                                            </li>
                                        </ul>
                                    </div>
                                    <p className="imgBox">
                                        <img alt="" src={exImg01} />
                                    </p>
                                </div>
                            </div>
                            <div className="contents ex03">
                                <p className="imgBox">
                                    <img alt="" src={exImg02} />
                                </p>
                                <div className="textBox">
                                    <h3>
                                        <span className="eng">PLAYAPI</span> 도입으로 달라진점은 무엇인가요?
                                    </h3>
                                    <p>
                                        PLAYAPI 도입으로 쇼핑몰과 연동 프로세스 구축에 대한 리소스가 대폭 감소하며{' '}
                                        <br />
                                        빠르게 원스탑 플랫폼이 완성되어 안정적인 서비스를 제공하고 있습니다. <br />
                                        이렇게 줄어드는 업무 리소스로 인해 타 서비스와의 차별점을 더욱 강화하고, <br />
                                        다양한 서비스를 구상하고 있습니다.
                                    </p>
                                </div>
                            </div>
                            <div className="bg-skyblue">
                                <div className="processWrap">
                                    <div className="textBox">
                                        <h3>몰테일쉽투비 프로세스</h3>
                                    </div>
                                    <p className="imgBox">
                                        <img alt="" src={exImg03} />
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                    {coupang && (
                        <div className="exCon02">
                            <div className="contents ex04">
                                <p className="imgBox">
                                    <img alt="" src={coupangLogo} />
                                </p>
                                <div className="textBox">
                                    <h3>
                                        <span className="colorPrimary">쿠팡</span>
                                    </h3>
                                    <p>
                                        차별화된 물류 서비스로 서비스 만족도 및 브랜드 평판 1위를 유지하며, <br />
                                        안정적인 서비스를 제공하고 있습니다.
                                    </p>
                                </div>
                            </div>
                            <div className="bg-lightGray">
                                <div className="contents ex05">
                                    <div className="textBox">
                                        <h3>도입한 연동 패키지</h3>
                                        <p>
                                            PLAYAPI의 타 채널에서 판매중인 상품 가져오기 기능을 이용해 쿠팡에 가져온
                                            상품을 <br />
                                            상품등록 할 수 있도록 PLAYAPI를 도입하여 신규 입점 Seller의 부담을 줄여주는
                                            외부 몰 <br />
                                            상품자동등록(이관) 기능을 서비스하고 있습니다.
                                        </p>
                                        <ul>
                                            <li>
                                                <span className="icon icon-ex_icon01"></span>
                                                <b>상품관리</b> : 쇼핑몰 상품 가져오기 / 상품등록
                                            </li>
                                        </ul>
                                    </div>
                                    <p className="imgBox">
                                        <img alt="" src={exImg04} />
                                    </p>
                                </div>
                            </div>
                            <div className="contents ex06">
                                <p className="imgBox">
                                    <img alt="" src={exImg05} />
                                </p>
                                <div className="textBox">
                                    <h3>
                                        <span className="eng">PLAYAPI</span> 도입으로 달라진점은 무엇인가요?
                                    </h3>
                                    <p>
                                        신규 입점 Seller 또는 기존 Seller가 이미 외부몰에 판매중인 상품을 모두 <br />
                                        등록하는 부담을 줄여줄 수 있어, 빠른 판매가 가능하도록 기능을 지원하고 있습니다.{' '}
                                        <br />
                                        많은 상품DB를 등록해야 하는 부담을 줄여줘 신규 입점 seller 및 상품DB의 <br />
                                        빠른 확장의 효과를 경험하고 있습니다.
                                    </p>
                                </div>
                            </div>
                            <div className="bg-skyblue">
                                <div className="processWrap">
                                    <h3>Wakeup 모델 프로세스</h3>
                                    <div className="textBox">
                                        <ul className="processDesc">
                                            <li>
                                                <img alt="" src={exImg06_1} />
                                                <p>판매중인 상품 DB</p>
                                            </li>
                                            <li className="arrow">
                                                <img alt="" src={arrow} />
                                            </li>
                                            <li>
                                                <img alt="" src={exImg06_2} />
                                                <p>PLAYAPI 상품 자동 연동</p>
                                            </li>
                                            <li className="arrow">
                                                <img alt="" src={arrow} />
                                            </li>
                                            <li>
                                                <img alt="" src={exImg06_3} />
                                                <p>쿠팡 상품 등록 완료</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="textBox">
                                        <h3 style={{ marginTop: '100px' }}>적용사례</h3>
                                        <div className="exDescWrap">
                                            <div className="exDesc exLeft">
                                                <img alt="" src={exImg07_1} />
                                                <span>01</span>
                                                <p className="exTitle">상품등록 방법 선택</p>
                                                <p>
                                                    플레이오토 활용한 무료 상품 등록 기능은
                                                    <br />
                                                    PLAYAPI를 이용한 등록 기능입니다.
                                                </p>
                                            </div>
                                            <div className="exDesc">
                                                <img alt="" src={exImg07_2} />
                                                <span>02</span>
                                                <p className="exTitle">상품을 수집할 쇼핑몰 선택</p>
                                                <p>
                                                    쿠팡에 등록하기 위해
                                                    <br />
                                                    가져오기 할 쇼핑몰을 선택해 줍니다.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default PlayApiExample;
